import Vue from "vue";
import { ObserveVisibility } from "vue-observe-visibility";
import "intersection-observer/intersection-observer";

Vue.directive("observe-visibility", ObserveVisibility);
